<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div :class="['form-item', { error: item.error }]" :data-name="item.name">
    <div
      :class="[
        'form-label',
        'c-muli-semibold',
        { horizontal: item.horizontal, required: item.required },
      ]"
    >
      {{ item.label }}
    </div>
    <c-input
      v-if="item.type === 'input'"
      v-model="state.value"
      :maxlength="item.maxlength"
      :error="item.error"
      class="form-input"
      @change="$emit('change', state.value)"
    />
    <c-input
      v-if="item.type === 'textarea'"
      v-model="state.value"
      :rows="rows"
      :maxlength="item.maxlength"
      :error="item.error"
      :type="item.type"
      class="form-input"
      @focus="textareaFocus"
      @blur="textareaBlur"
      @change="$emit('change', state.value)"
    />
    <span class="flex justify-end">
      <!-- <span
        v-if="item.type === 'textarea'"
        class="mt-12px rounded-[128px] px-12px flex items-center h-28px"
        style="background: linear-gradient(94deg, #E2F2FD 5.64%,#F7F7CF 98.94%); vertical-align: middle"
      >
        <img src="./voice2text/imgs/star.svg">
        <span class="c-muli-bold text-12px text-[#219DE4] ml-4px">AI Writing</span>
      </span> -->
      <span v-if="item.type === 'textarea'" class="c-muli text-12px mt-8px"
        >{{ state.value?.length }} / {{ item.maxlength }}</span
      >
    </span>
    <c-rate
      v-if="item.type === 'rate'"
      v-model="state.value"
      size="large"
      :allow-half="false"
      @change="$emit('change', state.value)"
    />
    <c-input
      v-if="item.type === 0"
      v-model="state.value"
      class="form-input"
      @change="$emit('change', state.value)"
    />
    <template v-if="item.type === 1">
      <c-tag
        v-for="option in item.options"
        :key="option.option"
        :checked="item.value === option.option"
        :style="{
          marginRight: '16px',
          marginBottom: '16px',
          fontFamily:
            item.value === option.option
              ? 'Muli-Bold !important'
              : 'Muli-SemiBold !important',
        }"
        :class="{ 'checked-tag': item.value === option.option }"
        @click="item.value = option.option"
      >
        {{ option.option }}
      </c-tag>
    </template>
    <template v-if="item.type === 2">
      <c-tag
        v-for="option in item.options"
        :key="option.option"
        :checked="item.value.includes(option.option)"
        :style="{
          marginRight: '16px',
          marginBottom: '16px',
          fontFamily: item.value.includes(option.option)
            ? 'Muli-Bold !important'
            : 'Muli-SemiBold !important',
        }"
        :class="{ 'checked-tag': item.value.includes(option.option) }"
        @click="onClickCheckbox(option.option)"
      >
        {{ option.option }}
      </c-tag>
    </template>
    <!-- <c-radio-group
      v-if="item.type === 1"
      v-model="state.value"
      direction="horizontal"
      @change="$emit('change', state.value)"
    >
      <c-radio
        v-for="option in item.options"
        :key="option.sortNum"
        :name="option.sortNum"
      >
        {{ option.option }}</c-radio
      >
    </c-radio-group>
    <c-checkbox-group
      v-if="item.type === 2"
      v-model="state.value"
      direction="horizontal"
      @change="$emit('change', state.value)"
    >
      <c-checkbox
        v-for="option in item.options"
        :key="option.sortNum"
        :name="option.sortNum"
        >{{ option.option }}</c-checkbox
      >
    </c-checkbox-group> -->
    <div v-if="item.showRateText && state.value" class="rate-text c-muli-light">
      {{ $t("rateLevel" + state.value) }}
    </div>
    <div class="form-item-err c-muli" v-if="item.error && item.errText">
      {{ item.errText }}
    </div>
  </div>
  <VoiceCom
    v-if="item.type === 'textarea' && isMobile"
    v-model:show="showElementB"
    :is-i-o-s="isIOS"
    :item-value="item.value"
    :maxlength="item.maxlength"
    @saveText="saveText"
    @selfClick="preventBlur"
  />
</template>

<script setup>
/* eslint-disable */
import { defineProps, reactive, defineEmits, watch, ref } from "vue";
import VoiceCom from './voice2text/VoiceCom.vue';

const props = defineProps({
  item: Object,
  product: Object,
});

const emit = defineEmits(["change"]);

const state = reactive({
  value: props.item.value,
});
const isShowVoice = ref(false);
    const rows = ref(2);
    const showElementB = ref(false);
    const clickedOnB = ref(false);
    const textareaInput = ref(null);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    
    let viewportCheckTimer = null;
    const onBlur = () => {
      if (props.item.trigger === "blur") {
        props.item.rules.forEach((rule) => {
          if (!rule.validator(props.item.value)) {
            props.item.error = true;
            props.item.errText = rule.message;
          }
        });
      }
    };

    const saveText = (value) => {
      state.value = value;
      emit('change', state.value)
      showElementB.value = false;
    };
    const textareaFocus = () => {
      showElementB.value = true;
      clickedOnB.value = false;
      rows.value = 4;
      startViewportCheck();
    };
    const textareaBlur = () => {
      rows.value = 2;
      
      setTimeout(() => {
        clearInterval(viewportCheckTimer);
        resetElementPosition();
        if (!clickedOnB.value) {
          showElementB.value = false;
        }
      }, 1);
    };
    const preventBlur = () => {
      clickedOnB.value = true;
      showElementB.value = false;
      // 保持输入框聚焦状态
      // textareaInput.value.focus();
  
      // 300ms后重置状态，以便下次正常处理blur事件
      setTimeout(() => {
        clickedOnB.value = false;
      }, 30);
    };
  
    const onChange = () => {
      props.item.error = false;
    };
    function adjustElementPosition (distance) {
      const elementA = Array.from(document.querySelectorAll('#voice-icon')).find(dom => dom.style.display !== 'none');
      if (elementA) {
        // if (isIOS) {
          const parentDom = document.querySelector('#voice-position-container');
          const dis = window.visualViewport.height - 40 + (isIOS ? window.scrollY : window.visualViewport.pageTop || 0);
          elementA.style.top = dis + 'px';
          if(!document.querySelector('#voice-position-container #voice-icon')) {
            elementA.remove();
            parentDom.append(elementA);
          }
        // } else {
        //   elementA.style.bottom = distance + 10 + 'px';
        // }
      }
    }

    function resetElementPosition () {
      const elementA = Array.from(document.querySelectorAll('#voice-icon')).find(dom => dom.style.display !== 'none');
      if (elementA) {
        elementA.style.top = '1000px'
      }
    }

    // window.addEventListener('resize', () => {
    //   startViewportCheck();
    // });
    function startViewportCheck () {
      viewportCheckTimer = setInterval(() => {
        try {
          const distance = window.innerHeight - (window.visualViewport?.height || window.innerHeight);
          // && originalViewportHeight - window.innerHeight < 10
          // if (distance > 100 ) {
          adjustElementPosition(distance);
          // } else if(distance < 1) {
          //   adjustElementPosition(0);
          // }
        } catch (error) {}
        
      }, 100);
    }

const onClickCheckbox = (item) => {
  props.item.value.includes(item)
    ? // eslint-disable-next-line vue/no-mutating-props
      props.item.value.splice(props.item.value.indexOf(item), 1)
    : // eslint-disable-next-line vue/no-mutating-props
      props.item.value.push(item);
};
const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)

watch(
  () => props.product,
  (value) => {
    state.value = value.value;
  }
);
</script>

<style>
.checked-tag {
  background: #fff;
  border: 1px solid #000;
  color: #000;
  box-sizing: border-box;
}
</style>
